import createDocumentsClient from './createDocuments'
import generateUploadUrl from './generateUploadUrl'
import uploadDocument from './uploadDocument'
import uploadDocuments from './uploadDocuments'

import { MutationResolvers } from '../../../../../generated/graphql'

const documents: MutationResolvers = {
    createDocumentsClient,
    generateUploadUrl,
    uploadDocument,
    uploadDocuments,
}

export default documents
